<template>
  <LazyHomeCommonLayout>
    <template #content>
      <LazyHomeSubPagesOurCompanyAboutUsBanner/>
      <LazyHomeSubPagesOurCompanyAboutUsInfo/>
      <LazyHomeSubPagesOurCompanyAboutUsSwiper/>
      <LazyHomeSubPagesOurCompanyAboutUsNumberArea />
      <LazyHomeSubPagesOurCompanyCommonBottom />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {
  LazyHomeCommonLayout,
  LazyHomeSubPagesOurCompanyAboutUsBanner,
  LazyHomeSubPagesOurCompanyAboutUsInfo,
  LazyHomeSubPagesOurCompanyAboutUsNumberArea,
  LazyHomeSubPagesOurCompanyAboutUsSwiper,
  LazyHomeSubPagesOurCompanyCommonBottom
} from '#components';

useHead({
  title: 'About Codepresso: Reshaping the Tech Training Landscape',
  meta: [
    {
      name: 'description',
      content: "Discover our journey from vision to global impact. At Codepresso, we're dedicated to fostering a skilled, interconnected global tech community."
    },
    {
      name: 'title',
      content: 'About Codepresso: Reshaping the Tech Training Landscape'
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ]
})
</script>
